import React, { useContext } from 'react';
import { ThirdNavView, ThirdNavViewProps } from './ThirdNav.view';
import { TopNavContext } from '../../providers/TopNavProvider';

export type ThirdNavChildrenType = {
  left?: JSX.Element;
  right?: JSX.Element;
  center?: JSX.Element;
};

export type ThirdNavControllerProps = Omit<ThirdNavViewProps, 'secondNavVisibility' | 'thirdNav'> & {
  // Props
};

export const ThirdNavController = (props: ThirdNavControllerProps): JSX.Element => {
  const topNavOffsetContext = useContext(TopNavContext);
  const secondNavVisibility = topNavOffsetContext.state.visibility.second;

  if (!topNavOffsetContext.state.thirdNavChildren) {
    return <></>;
  }

  const viewProps: ThirdNavViewProps = {
    ...props,
    secondNavVisibility,
    thirdNav: topNavOffsetContext.state.thirdNavChildren
  };

  return <ThirdNavView {...viewProps} />;
};
